import React, { createContext, forwardRef, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { renewalVersion } from './renewalVersion';

const ExperienceContext = createContext(null);

// Resolve the version before mounting forms: mounting the wrong form could autosave data.
export function RenewalExperience({ children, caseId: propCaseId }) {
  const { caseId: routeCaseId } = useParams();
  const caseId = propCaseId || routeCaseId;
  const [result, setResult] = useState(null);
  useEffect(() => {
    let active = true;
    if (!caseId) {
      setResult({ caseId, version: null });
      return;
    }
    axios.get(`${config.API_URL}/RenewalCases/${caseId}`).then(({ data }) => {
      if (active) setResult({ caseId, version: renewalVersion(data) });
    }).catch(() => {
      if (active) setResult({ caseId, version: null });
    });
    return () => { active = false; };
  }, [caseId]);

  if (!result || result.caseId !== caseId) return <div role="status">Loading renewal…</div>;
  if (!result.version) return <div role="alert">Unable to determine the renewal version. Please reload or contact support to check the case’s renewal and creation dates.</div>;
  return <ExperienceContext.Provider value={result.version}>{children}</ExperienceContext.Provider>;
}

export function versioned(Current, Legacy) {
  const Component = forwardRef((props, ref) => {
    const version = useContext(ExperienceContext);
    // Admin previews pass a caseId instead of entering through a case route.
    if (!version) return <RenewalExperience caseId={props.caseId}><Component {...props} ref={ref} /></RenewalExperience>;
    const Selected = version === 'legacy' ? Legacy : Current;
    return <Selected {...props} {...(ref ? { ref } : {})} />;
  });
  Component.displayName = `Versioned(${Current.displayName || Current.name || 'Renewal'})`;
  return Component;
}
